/**
 * Seleção de grupos de acesso para configurações do Cockpit.
 */

import { Shield } from 'lucide-react'
import './AccessGroupPicker.css'

function AccessGroupPicker({
  groups = [],
  selectedIds = [],
  onChange,
  disabled = false,
  emptyMessage = 'Nenhum grupo de acesso ativo encontrado.',
}) {
  const selectedSet = new Set((selectedIds || []).map((id) => Number(id)))

  const toggleGroup = (groupId) => {
    if (disabled) return
    const id = Number(groupId)
    if (selectedSet.has(id)) {
      onChange((selectedIds || []).filter((item) => Number(item) !== id))
      return
    }
    onChange([...(selectedIds || []), id])
  }

  if (!groups.length) {
    return <p className="access-group-picker-empty">{emptyMessage}</p>
  }

  return (
    <div className="access-group-picker">
      {groups.map((group) => {
        const id = Number(group.id)
        const checked = selectedSet.has(id)
        return (
          <label
            key={group.id}
            className={`access-group-picker-item${checked ? ' is-selected' : ''}${disabled ? ' is-disabled' : ''}`}
          >
            <input
              type="checkbox"
              checked={checked}
              disabled={disabled}
              onChange={() => toggleGroup(id)}
            />
            <span className="access-group-picker-icon" aria-hidden>
              <Shield size={16} />
            </span>
            <span className="access-group-picker-content">
              <span className="access-group-picker-name">{group.name}</span>
              {group.description ? (
                <span className="access-group-picker-description">{group.description}</span>
              ) : null}
            </span>
          </label>
        )
      })}
    </div>
  )
}

export default AccessGroupPicker
